import { isUndefinedOrNull } from 'util/checks'

export function getNumeroMoradoresFormatado(numeroMoradores: number | null): string {
  if (isUndefinedOrNull(numeroMoradores)) return '-'
  return numeroMoradores + ' morador' + (numeroMoradores === 1 ? '' : 'es')
}
